var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10049_964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0C4.81331 0 3.65328 0.351894 2.66658 1.01118C1.67989 1.67047 0.910851 2.60754 0.456725 3.7039C0.00259969 4.80025 -0.11622 6.00665 0.115291 7.17054C0.346802 8.33443 0.918247 9.40352 1.75736 10.2426C2.59648 11.0818 3.66557 11.6532 4.82946 11.8847C5.99335 12.1162 7.19974 11.9974 8.2961 11.5433C9.39246 11.0891 10.3295 10.3201 10.9888 9.33342C11.6481 8.34672 12 7.18669 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0ZM9 5.83875C8.89979 5.93678 8.76518 5.99167 8.625 5.99167C8.48482 5.99167 8.35021 5.93678 8.25 5.83875L6.525 4.125V9.4275C6.525 9.56674 6.46969 9.70027 6.37123 9.79873C6.27278 9.89719 6.13924 9.9525 6 9.9525C5.86076 9.9525 5.72723 9.89719 5.62877 9.79873C5.53031 9.70027 5.475 9.56674 5.475 9.4275V4.1775L3.81375 5.83875C3.7143 5.9382 3.5794 5.99408 3.43875 5.99408C3.2981 5.99408 3.16321 5.9382 3.06375 5.83875C2.9643 5.73929 2.90842 5.6044 2.90842 5.46375C2.90842 5.3231 2.9643 5.1882 3.06375 5.08875L6.03 2.1375L9 5.09625C9.04876 5.145 9.08743 5.20288 9.11382 5.26658C9.14021 5.33028 9.15379 5.39855 9.15379 5.4675C9.15379 5.53645 9.14021 5.60472 9.11382 5.66842C9.08743 5.73212 9.04876 5.79 9 5.83875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10049_964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuys);
export default __webpack_public_path__ + "static/media/buys.9188ea7719947b9c96ac4ed29ca6de55.svg";
export { ForwardRef as ReactComponent };